import React, { useEffect, useState } from "react";
import { Users, Star } from "lucide-react";
import { useLang } from "../lib/i18n";
import { api } from "../lib/api";

const THRESHOLD = 10;

export default function SocialProofBadge() {
  const { lang } = useLang();
  const isFr = lang === "fr";
  const [data, setData] = useState({ count: 0, average: 0 });

  useEffect(() => {
    api.get("/reviews?limit=1").then((r) => {
      setData({ count: r.data?.count || 0, average: r.data?.average || 0 });
    }).catch(() => {});
  }, []);

  if (data.count < THRESHOLD) return null;

  return (
    <div
      data-testid="social-proof-badge"
      className="inline-flex items-center gap-3 px-4 py-2 rounded-full bg-white border-2 border-[#F4A261] shadow-sm"
    >
      <div className="flex -space-x-2">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="w-7 h-7 rounded-full ring-2 ring-white grid place-items-center text-white text-[11px] font-heading"
            style={{
              background: ["#F4A261", "#E07A5F", "#81B29A"][i],
            }}
          >
            <Users className="w-3 h-3" />
          </div>
        ))}
      </div>
      <div className="flex flex-col leading-tight">
        <div className="text-sm font-heading text-[#3D405B]">
          {isFr ? (
            <>Recommandé par <span className="text-[#E07A5F] font-bold">{data.count}</span> parents</>
          ) : (
            <><span className="text-[#E07A5F] font-bold">{data.count}</span> parents recommend The Gang</>
          )}
        </div>
        <div className="flex items-center gap-1 text-[11px] text-[#8A8D91]">
          <div className="flex items-center gap-0.5">
            {[1, 2, 3, 4, 5].map((n) => (
              <Star
                key={n}
                className="w-3 h-3"
                fill={n <= Math.round(data.average) ? "#F4A261" : "none"}
                stroke={n <= Math.round(data.average) ? "#F4A261" : "#B9BAC0"}
                strokeWidth={2}
              />
            ))}
          </div>
          <span className="font-semibold">{data.average.toFixed(1)}/5</span>
        </div>
      </div>
    </div>
  );
}
